import { getEnvironmentName } from "parog-web/utils/runtime-environment";
import type { Issuer } from "./open-id-connect";
import OpenIdConnectService from "./open-id-connect";

export default class ProSanteConnect extends OpenIdConnectService {
  label = "Pro Santé Connect";
  imageUrl = "/assets/ui-images/pro-sante-connect-logo.svg";
  issuer: Issuer = "pro-sante-connect";
  route = "login.pro-sante-connect";

  get isEnabled() {
    return this.isDevelopment;
  }

  get logoutUrl(): string {
    return `${this.logoutBaseUrl}?post_logout_redirect_uri=${this.logoutRedirectUri}`;
  }

  private get baseUrl(): string {
    return window.location.origin;
  }

  private get isDevelopment(): boolean {
    return (
      ["local", "master"].includes(getEnvironmentName()) ||
      this.baseUrl.includes("test")
    );
  }

  private get logoutRedirectUri(): string {
    return `${this.baseUrl}/medics-web/logout&id_token_hint=${this.idToken}`;
  }

  private get idToken(): string {
    return this.session.data?.authenticated?.id_token;
  }

  private get logoutBaseUrl(): string {
    return this.isDevelopment
      ? "https://auth.bas.psc.esante.gouv.fr/auth/realms/esante-wallet/protocol/openid-connect/logout"
      : "https://auth.esw.esante.gouv.fr/auth/realms/esante-wallet/protocol/openid-connect/logout";
  }
}
